import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Header, PageContent, Container, Table, SpinnerDimmed, Alerts, Toggle } from 'components';
import { Margin } from 'styled-components-spacing';
import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import { useTranslation } from 'react-i18next';
import {
  loadIpmaRegOfficeStatTableCreator,
  toggleIpmaRegOfficeCourseFrCreator,
} from 'store/actionsCreators';
import { RegRow } from './RegTable.styled';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.ipma.office',
    url: '/ipma/reg-office-hub',
  },
  {
    title: 'navigation.breadcrumbs.ipma.regTable',
    url: '',
  },
];

const RegTable = ({ items, loading, loadStatTable, toggleCourseFr }) => {
  const { t } = useTranslation();

  useEffect(() => {
    loadStatTable();
  }, []);

  const handleToggleFlatRate = (courseId, newValue) => toggleCourseFr({ courseId, newValue });

  return (
    <>
      <Header breadcrumbs={breadcrumbs} title={t('page.ipma.officeTable.name')} />
      <PageContent>
        <Container>
          <Margin bottom={{ md: 48 }}>
            <Alerts type="ipma" />
          </Margin>
          <Margin>
            <Table tablebreakpoint="lg">
              <Table.Head>
                <Table.Row>
                  <Table.Heading>{t('page.ipma.officeTable.memberAssociation')}</Table.Heading>
                  <Table.Heading>{t('page.ipma.officeTable.regPartner')}</Table.Heading>
                  <Table.Heading>{t('page.ipma.officeTable.courseName')}</Table.Heading>
                  <Table.Heading>{t('page.ipma.officeTable.regNumber')}</Table.Heading>
                  <Table.Heading>{t('page.ipma.officeTable.flatRate')}</Table.Heading>
                  <Table.Heading>{t('page.ipma.officeTable.cpdHours')}</Table.Heading>
                  <Table.Heading>{t('page.ipma.officeTable.diplomas')}</Table.Heading>
                </Table.Row>
              </Table.Head>
              <Table.Body style={{ position: 'relative', height: '80px' }}>
                {loading ? <SpinnerDimmed /> : null}
                {!loading && !items.length ? (
                  <Table.Row>
                    <Table.Cell colSpan={7}>{t('global.noResultsFound')}</Table.Cell>
                  </Table.Row>
                ) : null}
                {!loading && items.length
                  ? items.map((item, index) => (
                      <RegRow key={`${item.courseName}-${index}`} isOdd={(index + 1) % 2 !== 0}>
                        <Table.Cell style={{ fontWeight: 600, color: '#4F4E5C' }}>
                          <Table.Label>{t('page.ipma.officeTable.memberAssociation')}:</Table.Label>
                          {item.maName}
                        </Table.Cell>
                        <Table.Cell>
                          <Table.Label>{t('page.ipma.officeTable.regPartner')}:</Table.Label>
                          {item.partnerName}
                        </Table.Cell>
                        <Table.Cell>
                          <Table.Label>{t('page.ipma.officeTable.courseName')}:</Table.Label>
                          {item.courseName}
                        </Table.Cell>
                        <Table.Cell>
                          <Table.Label>{t('page.ipma.officeTable.regNumber')}:</Table.Label>
                          {item.regNumber}
                        </Table.Cell>
                        <Table.Cell style={{ textAlign: 'center' }}>
                          <Table.Label>{t('page.ipma.officeTable.flatRate')}:</Table.Label>
                          <Toggle
                            on={item.flatRate}
                            onClick={() => handleToggleFlatRate(item.id, !item.flatRate)}
                          />
                        </Table.Cell>
                        <Table.Cell style={{ textAlign: 'center' }}>
                          <Table.Label>{t('page.ipma.officeTable.cpdHours')}:</Table.Label>
                          {item.cpdHours}
                        </Table.Cell>
                        <Table.Cell style={{ textAlign: 'center' }}>
                          <Table.Label>{t('page.ipma.officeTable.diplomas')}:</Table.Label>
                          {item.diplomas}
                        </Table.Cell>
                      </RegRow>
                    ))
                  : null}
              </Table.Body>
            </Table>
          </Margin>
        </Container>
      </PageContent>
    </>
  );
};

RegTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
  loadStatTable: PropTypes.func.isRequired,
  toggleCourseFr: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ipma, loading }) => ({
  loading: isLoading(loading, 'IPMA'),
  items: ipma.regOfficeTable.items,
});

const mapDispatchToProps = (dispatch) => ({
  loadStatTable: () => dispatch(loadIpmaRegOfficeStatTableCreator()),
  toggleCourseFr: (payload) => dispatch(toggleIpmaRegOfficeCourseFrCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegTable);
